import globalAxios from "axios";
import { takeLatest } from "redux-saga/effects";

import { axios } from "utils/axios";
import { getLanguageStringFromLocaleString } from "utils/localeHelpers";
import { CHANGE_LOCALE } from "./constants";

export function* changeLocale(action) {
  const { locale } = action;
  axios.defaults.headers.common["Diverst-Locale"] =
    getLanguageStringFromLocaleString(locale);
  globalAxios.defaults.headers.common["Diverst-Locale"] =
    getLanguageStringFromLocaleString(locale);
}

export default function* languageProviderSaga() {
  yield takeLatest(CHANGE_LOCALE, changeLocale);
}
